// Dynamically resolve API base URL.
// When accessed from a custom domain (different from REACT_APP_BACKEND_URL),
// use same-origin /api calls to avoid cross-origin cookie/CORS issues.
const CONFIGURED = process.env.REACT_APP_BACKEND_URL || '';
const USE_SAME_ORIGIN = window.location.origin !== CONFIGURED;

export const BACKEND_URL = USE_SAME_ORIGIN ? '' : CONFIGURED;
export const API_BASE = `${BACKEND_URL}/api`;
